import { NumericInput } from '@pulse-web-ui/numeric-input';
import { media, styled, typography } from '@pulse-web-ui/theme';

export const PageTitle = styled.h1<{ marginBottom?: number }>`
  ${typography.medium20};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? `${marginBottom}px` : '8px'};

  ${media.desktop} {
    ${typography.medium24};
  }
`;

export const CustomNumericInput = styled(NumericInput)`
  ${typography.medium16};
  line-height: 24px;

  ${media.desktop} {
    ${typography.medium18};
  }
`;

export const SectionTitle = styled.h4`
  ${typography.medium16};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 16px;
  line-height: 24px;

  ${media.desktop} {
    ${typography.medium18};
    line-height: 26px;
  }
`;
